// useGetAllDateFieldOptions.js
import { useGetQueryData } from "@/utils/react-query-hooks/general";
import { extractAllBlocksFromTpl, segrigateDocs } from '@okf/ootils';

export const useGetAllDateFieldOptions = () => {
  const allTpls = useGetQueryData('allTpls');
  
  if (!allTpls) {
    return { options: [] };
  }

  const dateFieldOptions = [];

  // Get all publishing content types
  const publishingTpls = allTpls.filter(tpl => tpl.general?.segment === 'publishing');

  publishingTpls.forEach(tpl => {
    const contentType = tpl.kp_content_type;
    const contentTypeDisplay = tpl.general?.content?.title || contentType;
    
    const allBlocks = extractAllBlocksFromTpl({ tpl });
    
    // Filter for date-related fields
    const dateBlocks = allBlocks.filter(block => {
      const comp = block.comp;
      // Include DatePicker and DateTime components
      return ['DatePicker', 'DateTimePicker'].includes(comp);
    });


    dateBlocks.forEach(block => {
      dateFieldOptions.push({
        display: block.props?.label ||  `${block.comp} (${block.valuePath})`,
        value: `${block.valuePath}_${contentType}`,
        valuePath: block.valuePath,
        contentType: contentType,
        comp: block.comp,
      });
    });
  });

  publishingTpls.forEach(tpl => {
    const contentType = tpl.kp_content_type;
    const contentTypeDisplay = tpl.general?.content?.title || contentType;
    
    dateFieldOptions.push(
      {
        display: `Created Date`,
        value: `createdDate_${contentType}`,
        valuePath: `kp_date_published`,
        contentType: contentType,
        comp: 'Date'
      }
    );
  });

  const groupedOptions = Object.keys(segrigateDocs(dateFieldOptions, 'contentType')).map(ct => ({
    display: allTpls.find(tpl => tpl.kp_content_type === ct)?.general?.content?.title || ct,
    options: segrigateDocs(dateFieldOptions, 'contentType')[ct]
  }));

  return { options: groupedOptions };
};


// _extractWidgetTitle.js - Add to existing file or create new
export const getDerivedTimeSeriesTitle = ({dateField, dimension, interval}) => {
  if (!dateField) return null;
  
  const intervalDisplay = {
    'hour': 'Hourly',
    'day': 'Daily',
    'week': 'Weekly',
    'month': 'Monthly',
    'year': 'Yearly'
  }[interval?.value] || interval;

  const dateDisplay = dateField?.display || dateField?.valuePath || 'Date';
  
  if (!dimension) {
    return `${intervalDisplay} ${dateDisplay}`;
  }
  
  const dimensionDisplay = dimension?.display || dimension?.valuePath || 'Dimension';
  return `${dateDisplay} X ${dimensionDisplay}`;
};
